import { render } from "./form-mobile.vue?vue&type=template&id=48a8802b"
import script from "./form-mobile.js?vue&type=script&lang=js&external"
export * from "./form-mobile.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__